<template>
  <div>
    <my-header :activeIndex="3" />
    <!-- <div class="soild_text_one game-main">
      <div class="soild_text_three">关于我们</div>
    </div> -->
    <div class="main">
      <img
        src="../../assets/news/img.jpg"
        style="width: 80%; margin-left: 10%"
      />

      <div class="content-box">
        <div>
          <p class="title">游哉游戏平台：游戏世界的欢乐家园</p>
          <p>
            游哉游戏平台，作为游戏领域的新兴力量，正以独特的魅力和丰富的资源，为广大玩家与游戏厂商搭建起一座互动交流的桥梁。
          </p>
          <p>
            对于玩家而言，这里是游戏下载的宝藏之地。我们汇聚了海量的游戏资源，涵盖各种类型与风格，无论是紧张刺激的动作冒险，还是烧脑益智的策略解谜；无论是热血竞技的多人对战，还是沉浸感十足的角色扮演，都能在这里轻松找到。每一款游戏都经过精心筛选与优化，确保玩家能够享受到流畅、精彩的游戏体验。简洁直观的下载界面，让玩家能够迅速获取心仪的游戏，开启一段段奇妙的游戏旅程。
          </p>
          <p>
            而对于游戏厂商来说，游哉游戏在线是展示产品、拓展市场的绝佳平台。我们提供专业的入驻服务，以强大的技术支持和广泛的推广渠道，助力游戏产品精准触达目标玩家群体。丰富的运营经验和深度的市场分析，能够帮助厂商更好地了解玩家需求，优化产品策略，实现游戏的商业价值最大化。
          </p>
          <p>
            游哉游戏在线始终秉持着 “以用户为中心，以品质为导向” 的理念，致力于打造一个公平、公正、充满活力的游戏生态环境。在这里，玩家可以尽情畅享游戏的乐趣，游戏厂商能够实现品牌的成长与突破。未来，游哉游戏在线将不断创新与进取，与广大玩家和游戏厂商携手共进，共同书写游戏世界的精彩篇章。
          </p>
        </div>
      </div>
      <!-- <div class="top">
        <img src="../../assets/news/01.jpg" />
        <div class="content">
          <div>
            <p class="h1">新游推荐丨《守护者之森》在线送VIP</p>
            <p class="gary">发布时间：2024-10-25</p>
            <p class="gary text">
              欢迎穿越时光，重返青葱岁月!集结5位伙伴，扮演年英雄激发小宇宙，与魔王大军战斗!建造秘密营地，钓鱼挖宝，收集儿时玩具，寻觅传说宝藏...<br />
              游戏特色玩法:<br />
              【伙伴养成】：经典RPG卡牌养成，机甲战士、美少女<br />
              【策略搭配】：Rouglike肉鸽玩法，职业+技能搭配多样!<br />
              【关卡地图】：上天入地，百种关卡，穿越时空!等你来战!<br />
              【小宇宙】：激发小宇宙成长，提升能量、突破上限!<br />
              【寻宝】：收集玩具藏品，铁皮青蛙、照相小熊，感动重温!<br />
              【钓鱼】：丰富鱼种、奇趣鱼缸，多样技能策略!等你体验!<br />
              更多精彩玩法，持续火热推出、敬请期待！经典重现，快乐无价，让我们一起携手出发吧！
            </p>
          </div>
        </div>
      </div>
      <img src="../../assets/news/loding-game.jpg" style="width: 100%" /> -->
      <!-- <div class="center">
        <div
          class="content"
          @click="open(item.url)"
          v-for="(item, index) in contentData"
          :key="index"
        >
          <p
            class="h1"
            style="height: 50px; display: flex; align-items: center"
          >
            {{ item.name }}
          </p>
          <img :src="item.img" />
          <p class="gary">{{ item.text }}</p>
        </div>
      </div> -->
      <!-- <div class="bottom">
        <div class="tabs">
          <div v-for="(item, index) in tabs" :key="index">
            <div
              class="box"
              @click="handleClickTabs(index)"
              :class="active == index ? 'active' : null"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="(item, index) in newsData"
        :key="index"
      >
        <div v-if="item.key.includes(active)"  class="bottom-content">
          <div>{{ item.title }}</div>
          <div class="right-content">
            <div>{{ item.company }}</div>
            <div>•</div>
            <div>{{ item.date }}</div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <my-footer style="margin-top: 20px" /> -->
    <div style="margin-top: 20px" class="footer-box">
      <p>Contact Us</p>
      <p>联系我们</p>
      <div class="footer-contet">
        <div class="box">
          <img src="../../assets/news/bottom-01.jpg" />
          <div>
            <p>联系方式</p>
            <p>地址：广州市天河区迎龙路199号之二三层302房A742号</p>
            <p>联系电话：13316158306</p>
          </div>
        </div>
        <div class="box">
          <img src="../../assets/news/bottom-02.jpg" />
          <div>
            <p>商务合作</p>
            <p>联系邮箱：huangmingzhu@iwgame.com</p>
          </div>
        </div>
        <div class="box">
          <img src="../../assets/news/bottom-03.jpg" />
          <div>
            <p>游戏客服</p>
            <p>客服公众号：游哉手游</p>
            <p>客服邮箱：wendalian@iwgme.com</p>
          </div>
        </div>
      </div>
    </div>
    <my-footer />
    <my-top />
  </div>
</template>
<script>
import MyFooter from "./MyFooter.vue";
import MyHeader from "./MyHeader.vue";
import MyTop from "./MyTop.vue";
export default {
  name: "about",
  components: {
    "my-footer": MyFooter,
    "my-header": MyHeader,
    "my-top": MyTop,
  },
  data() {
    return {
      contentData: [
        {
          name: "新游推荐丨龙珠类卡牌手游《七龙珠集结》",
          img: require("../../assets/news/02.png"),
          text: "突破传统卡牌玩法，独创家园系统，百抽福利、免费赠送......",
          url: "https://mp.weixin.qq.com/s/fU8nOK_kPsF28oRMY_oqwQ",
        },
        {
          name: "琴剑封魔录丨助力攻略",
          img: require("../../assets/news/03.png"),
          text: "让您开局更畅快，附带助力礼包，记得领取哦......",
          url: "https://mp.weixin.qq.com/s/ilj34MTAiBe2XVHu09Xk7A",
        },
        {
          name: "新游推荐|年度武侠大作《天之禁》",
          img: require("../../assets/news/04.png"),
          text: "极致爽快的打击体验、精美的游戏画面、富有新意的游戏体验......",
          url: "https://mp.weixin.qq.com/s/qG4nxEgDNkN3IGT9sZ_r7Q",
        },
      ],
      active: 0,
      tabs: [
        { name: "全部", key: 0 },
        { name: "活动", key: 1 },
        { name: "公告", key: 2 },
        { name: "攻略", key: 3 },
      ],
      newsData: [
        {
          key: [0, 2],
          title: "【公告】《幻灵修仙传》11月17日安卓新服上线!",
          company: "游哉互娱",
          date: "21-12-15",
        },
        {
          key: [0, 1],
          title:
            "【活动】参与《火之影：羁绊》黄金周的线下返利活动获得手办周边等大奖",
          company: "游哉互娱",
          date: "21-09-10",
        },
        {
          key: [0, 2],
          title:
            "【公告】游哉互娱：坚持支持和积极响应防止未成年人沉迷网络游戏规定的声明",
          company: "游哉互娱",
          date: "21-08-30",
        },
        {
          key: [0, 1],
          title: "【活动】《仙梦情缘》幸福狂欢锦鲤相伴活动预告",
          company: "游哉互娱",
          date: "21-07-15",
        },
        {
          key: [0, 3],
          title: "【攻略】法师克星|新职业降世最全资料提前知！",
          company: "游哉互娱",
          date: "21-06-01",
        },
        {
          key: [0, 1],
          title: "【活动】盛装霓虹《幻灵修仙传》周年庆活动！礼包全面升级！",
          company: "游哉互娱",
          date: "21-05-08",
        },
        {
          key: [0, 1],
          title:
            "【活动】全新限量武器玩出无数花样。更有专属呆萌可爱的小宠物伴你同行！绝对不能错过!",
          company: "游哉互娱",
          date: "21-04-04",
        },
        {
          key: [0, 3],
          title: "【攻略】传奇至尊|屠龙必须上穿透！再问就拿去附灵吧！",
          company: "游哉互娱",
          date: "21-03-12",
        },
        {
          key: [0, 3],
          title: "【攻略】剑仙培养之我见，小鲜肉应该这样肉！",
          company: "游哉互娱",
          date: "21-02-20",
        },
        {
          key: [0, 2],
          title: "【公告】卧龙出，祥瑞至，超级齐天大神新春登场！",
          company: "游哉互娱",
          date: "21-02-01",
        },
      ],
    };
  },
  // mounted() {
  //   if (this.$isMobile()) {
  //     require("../../../css/news-phone.min.css");
  //   } else {
  //     require("../../../css/news.min.css");
  //   }
  // },
  methods: {
    open(url) {
      window.open(url);
    },
    handleClickTabs(index) {
      this.active = index;
    },
  },
};
</script>
<style scoped>
@import url(../../../css/news-phone.min.css);
.game-main {
  margin: 0 auto;
}
.soild_text_three {
  position: relative;
  text-align: center;
  margin: 10px auto;
  height: 20px;
  font-size: 14px;
  color: #7bc4cc;
}
.soild_text_three::before {
  content: "";
    position: absolute;
    top: 50%;
    border: solid 1px #c5e3e8;
    width: 35%;
    left: 0;
}
.soild_text_three::after {
  content: "";
    position: absolute;
    top: 50%;
    border: solid 1px #c5e3e8;
    width: 35%;
    right: 0;
}
.content-box {
  width: 90%;
  margin-left: 5%;
  display: flex;
  font-size: large;
  line-height: 2rem;
}
.content-box img {
  margin-right: 20px;
}
.content-box .title {
  font-weight: bold;
  color: cornflowerblue;
  font-size: larger;
  text-align: center;
  margin: 20px 0;
}
.footer-box {
  background-color: #000;
  color: #fff;
  text-align: center;
  padding: 20px;
  font-size: smaller;
}
.footer-contet {
  /* display: flex;
  justify-content: space-around; */
  background-color: #2a2a2a;
  padding: 20px;
  margin-top: 1rem;
}
.footer-contet .box {
  display: flex;
  text-align: left;
  align-items: center;
  margin-bottom: 1rem;
}
.footer-contet .box img {
  width: 5rem;
  margin-right: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/news.vue